module.exports = __webpack_public_path__ + "static/media/RashadWalcott_Resume.285be918.pdf";